export const RECAPTCHA_SITE_KEY = "6Lc1bgETAAAAADWZEULuTsv_Wmw9psIiQaiisQRr";
export const RECAPTCHA_SITE_KEY_V3 = "6LeCLJQUAAAAAKhURwuhfsdYVsF2BWLJwZfTrDGJ";
export const SENTRY_DSN = "https://40ca79dfbcf04b938854f91b64100cc3@sentry.io/43220";



// WEBPACK FOOTER //
// ./src/shared/util/constants.js